import { GetPagaresAceptablesDtoProps } from "./DTOs/GetPagaresAceptablesDto"

export const pagaresAceptableAdapter = (
  pagares: GetPagaresAceptablesDtoProps
): GetPagaresAceptablesDtoProps => {
  return {
    id: pagares.id,
    estado: pagares.estado,
    fechaEmision: pagares.fechaEmision,
    importe: pagares.importe,
    librador: pagares.librador,
    numero: pagares.numero,
  }
}
